import { IApiService } from '../../api/api.service';

export default class SellerResponseService {
  rfpId;

  constructor(
    private api: IApiService,
    private LoadingIndicator,
    private $rootScope,
    private ResponsePermissions,
  ) {
    'ngInject';
  }

  getRfp() {
    return this.rfpId;
  }
  loadAccount() {
    let loader = this.api.users.currentUser();

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadFeatures() {
    let loader = this.api.features.getFeatures();

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadPermissions(userId, rfpId, sellerId, ResponsePermissions) {
    let loader = this.api.users.getResponsePermissions(userId, rfpId, sellerId);

    this.LoadingIndicator.waitFor(loader);

    loader.then((permissions) => {
      this.ResponsePermissions.setPermissions(permissions);
    });

    return loader;
  }

  loadRfp(rfpId) {
    let loader = this.api.rfps.getRfp(rfpId);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadOffers(rfpId, sellerId) {
    let loader = this.api.rfps.loadOffers(rfpId, sellerId);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadSpend(rfpId, sellerId) {
    let loader = this.api.rfps.sellers.getSpend(rfpId, sellerId);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadRfpOld(rfpId) {
    // Load the old rfp - this is slow (~7 seconds)
    let loader = this.api.rfps.getRfp(rfpId);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  setPageTitle(pageTitle) {
    this.$rootScope.pageTitle = pageTitle;
  }

  getAttachments(rfpId) {
    let loader = this.api.rfps.getAttachments(rfpId);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }
}
